// extracted by mini-css-extract-plugin
export default {"productList":"ProductList_productList__mj3uS","productItem":"ProductList_productItem__g1KDG"};